import styled from '@emotion/styled'

const Wrapper = styled.div`
  margin-bottom: 4rem;

  a {
    cursor: pointer;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.phone}px) {
    margin-bottom: 9.305555555555556vw;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.largeDesktop}px) {
    margin-bottom: 7.444444444444444rem;
  }
`

const Figure = styled.figure`
  width: 100%;

  img {
    width: 100%;

    opacity: 0;
    transition: all 0.5s ease;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.phone}px) {
    width: 42%;
  }
`

const Info = styled.div`
  width: 100%;
  margin-top: 0.75rem;

  overflow: hidden;

  @media (min-width: ${({ theme }) => theme.breakpoints.phone}px) {
    width: 52%;
    margin-top: 0;
  }
`

const Title = styled.h2`
  font-size: 2rem;
  letter-spacing: -1.06667px;

  color: ${({ theme }) => theme.colors.primary};

  opacity: 0;
  transform: translate(0, 100%);
  transition: all 0.5s ease 0.5s;

  @media (min-width: ${({ theme }) => theme.breakpoints.phone}px) {
    font-size: 4.444444444444444vw;
    color: ${({ theme }) => theme.colors.primaryLightest};
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.largeDesktop}px) {
    font-size: 3.555555555555556rem;
  }
`

const Summary = styled.div`
  margin-top: 0.25rem;

  opacity: 0;
  transform: translate(0, 100%);
  transition: all 0.5s ease 1s;

  > p {
    line-height: 22px;
    letter-spacing: 0.64px;

    @media (min-width: ${({ theme }) => theme.breakpoints.phone}px) {
      letter-spacing: 0.82px;
      font-size: 0.6666666666666667rem;
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.tablet}px) {
      font-size: 0.7777777777777778rem;
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.desktop}px) {
      font-size: 0.8888888888888889rem;
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.largeDesktop}px) {
      font-size: 1rem;
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.phone}px) {
    margin-top: 0.8888888888888889rem;
  }
`

const Button = styled.div`
  min-width: 100%;
  margin-top: 0.875rem;

  text-align: right;
  text-transform: uppercase;
  font-size: 1rem;

  opacity: 0;
  transition: all 0.3s ease 1.5s;

  > a {
    color: ${({ theme }) => theme.colors.primaryDarkest};
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.phone}px) {
    margin-top: 1.333333333333333rem;

    text-align: left;
    font-size: 0.75rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}px) {
    font-size: 1.25vw;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.largeDesktop}px) {
    font-size: 1rem;
  }
`

const FlexContainer = styled.div`
  display: flex;
  flex-wrap: wrap;

  overflow: hidden;

  ${Figure} img {
    transform: translate(-100vw);
  }

  ${Button} {
    transform: translate(-100%);
  }

  &.active {
    ${Figure} img, ${Title}, ${Summary}, ${Button} {
      opacity: 1;
      transform: translate(0);
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.phone}px) {
    flex-direction: ${props => (props.reverse ? 'row-reverse' : 'row')};
    justify-content: space-between;

    ${Figure} img {
      transform: ${({ reverse }) =>
        reverse ? 'translate(-100vw)' : 'translate(100vw)'};
    }

    ${Button} {
      transform: ${({ reverse }) =>
        reverse ? 'translate(100%)' : 'translate(-100%)'};
    }
  }
`

export { Wrapper, FlexContainer, Figure, Info, Title, Summary, Button }
